import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import Logo from '@sitebase/web-shell-kit/es/header-kit/Logo';

import { subscribe, publish, unsubscribe } from '../patched-message-bus';
import { eventRequested, onCommandSelect } from './message-bus-helpers';

var type = '@sitebase/logo';

var sharedCurrentLink = { link: { url: '/' } };

var _onClick = function _onClick(e, data) {
  if (e) e.preventDefault();
  publish(eventRequested(data));
};

var LogoRenderer = function (_Component) {
  _inherits(LogoRenderer, _Component);

  function LogoRenderer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LogoRenderer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LogoRenderer.__proto__ || _Object$getPrototypeOf(LogoRenderer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentLink: _this.props.data
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LogoRenderer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.subscribeId = subscribe(onCommandSelect(function (data) {
        var currentLink = _this2.state.currentLink;

        if (currentLink.link.url !== data.link.url) {
          _this2.setState({ currentLink: data }, function () {
            sharedCurrentLink = data;
          });
        }
      }));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.subscribeId) unsubscribe(this.subscribeId);
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;
      var currentLink = this.state.currentLink;


      return React.createElement(Logo, {
        'data-test-id': '' + type + (data.id ? '_' + data.id : ''),
        url: currentLink.link.url,
        onClick: function onClick(e) {
          return _onClick(e, currentLink);
        }
      });
    }
  }]);

  return LogoRenderer;
}(Component);

LogoRenderer.defaultProps = {
  data: sharedCurrentLink
};


export default {
  type: type,
  render: function render(_ref2) {
    var data = _ref2.data;
    return React.createElement(LogoRenderer, { key: 'pih.logo', data: data });
  }
};
//# sourceMappingURL=logo.js.map